import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_DROPDOWN,
    GET_PRODUCTS_RECEIVESETS,
    GET_SHIP_TO_ADDRESS,
    GET_DERIVED_TERRITORIES,
    GET_PRICES_FOR_ITEMS,
    GET_CONSIGNMENT_DETAILS,
    GET_USAGE_DETAILS,
    GET_INVENTORY_DATA,
    USAGE_ATTACHMENT_UPLOAD,
    DELETE_ATTACHMENT_REQUEST,
    GET_IMAGE_PO_PREVIEW,
    VALIDATE_PRODUCT_DETAILS,
    UPDATE_CONSIGNMENT_DETAILS,
    SAVE_CONSIGNMENT_DETAILS,
    CREATE_RECEIVE_SETS,
    GET_BARCODE_RECEIVE_SETS,
    GET_PRODUCT_DETAILS,
    CHECK_IS_OUTSIDE_TERRITORY,
} from '../actions';
import receiveSetsSearchProducts from './productsSearchSaga';
import receiveSetsProductDetails from './productDetailsSaga';
import getReceiveSetsDropDownSaga from './getDropDownSaga';
//import productsTemplatesFilterSaga from './productsTemplatesFilterSaga';
import getShipToAddressSaga from './shipToAddressSaga';
import getDerivedTerritories from './derivedTerritorySaga';
import updateConsignment from './updateConsignmentSaga';
import createReceiveSets from './createReceiveSetsSaga';
import {
    getSetAndBatchReceiveSets,
    getProductDetails,
    checkIsOutsideTerritorySaga,
} from './getReceiveSetsDetails';
import {
    getConsignmentDetails,
    usageAttachmentUploadSaga,
    deleteAttachmentSaga,
    getImagePoPreviewSaga,
    validateProductDetailsInBillingSaga,
} from './getConsignmentDetailsSaga';
import getUsageDetails from './usageDetails';
import getInventoryDetails from './getInventoryDetailsSaga';
import saveConsignment from './createConsignmentSaga';
import getPricesForConsignmentItemsSaga from './getPricesForItemsSaga';

function* watchReceiveSetsGetDropDownSaga() {
    yield takeEvery(GET_DROPDOWN, getReceiveSetsDropDownSaga);
}

function* watchGetReceiveSetsDetails() {
    yield takeLatest(GET_BARCODE_RECEIVE_SETS, getSetAndBatchReceiveSets);
}

function* watchCheckFromOutsideTerritory() {
    yield takeEvery(CHECK_IS_OUTSIDE_TERRITORY, checkIsOutsideTerritorySaga);
}

function* watchGetReceiveSetsProductsSaga() {
    yield takeEvery(GET_PRODUCTS_RECEIVESETS, receiveSetsSearchProducts);
}

function* watchGetReceiveSetsProductsDetailsSaga() {
    yield takeEvery(GET_PRODUCT_DETAILS, receiveSetsProductDetails);
}

// function* watchGetProductsTemplatesFilterSaga() {
//     yield takeEvery(GET_PRODUCTSTEMPLATESFILTER, productsTemplatesFilterSaga);
// }

function* watchGetProductDetailsSaga() {
    yield takeEvery(GET_PRODUCT_DETAILS, getProductDetails);
}

function* watchGetShipToAddressSaga() {
    yield takeEvery(GET_SHIP_TO_ADDRESS, getShipToAddressSaga);
}


function* watchGetDerivedTerritoriesSaga() {
    yield takeLatest(GET_DERIVED_TERRITORIES, getDerivedTerritories);
}

function* watchGetConsignmentDetailsSaga() {
    yield takeLatest(GET_CONSIGNMENT_DETAILS, getConsignmentDetails);
}

function* watchGetUsageDetailsSaga() {
    yield takeLatest(GET_USAGE_DETAILS, getUsageDetails);
}

function* watchGetInventoryDetailsSaga() {
    yield takeLatest(GET_INVENTORY_DATA, getInventoryDetails);
}

function* watchUsageUploadAttcahmentSaga() {
    yield takeLatest(USAGE_ATTACHMENT_UPLOAD, usageAttachmentUploadSaga);
}
function* watchUsageDeleteAttcahmentSaga() {
    yield takeLatest(DELETE_ATTACHMENT_REQUEST, deleteAttachmentSaga);
}
function* watchGetImagePOPreviewSaga() {
    yield takeLatest(GET_IMAGE_PO_PREVIEW, getImagePoPreviewSaga);
}

function* watchValidateProductDetailsInBillingSaga() {
    yield takeLatest(
        VALIDATE_PRODUCT_DETAILS,
        validateProductDetailsInBillingSaga
    );
}
function* watchUpdateConsignmentSaga() {
    yield takeLatest(UPDATE_CONSIGNMENT_DETAILS, updateConsignment);
}
function* watchSaveConsignmentSaga() {
    yield takeLatest(SAVE_CONSIGNMENT_DETAILS, saveConsignment);
}
function* watchGetPricesForConsignmentItemsSaga() {
    yield takeLatest(GET_PRICES_FOR_ITEMS, getPricesForConsignmentItemsSaga);
}
function* watchCreateReceiveSetsSaga() {
    yield takeLatest(CREATE_RECEIVE_SETS, createReceiveSets);
}
export default function* receiveSetsRootSaga() {
    yield all([
        fork(watchGetConsignmentDetailsSaga),
        fork(watchGetUsageDetailsSaga),
        fork(watchGetInventoryDetailsSaga),
        fork(watchGetShipToAddressSaga),
        fork(watchUsageUploadAttcahmentSaga),
        fork(watchUsageDeleteAttcahmentSaga),
        fork(watchGetImagePOPreviewSaga),
        fork(watchValidateProductDetailsInBillingSaga),
        fork(watchGetDerivedTerritoriesSaga),
        fork(watchUpdateConsignmentSaga),
        fork(watchSaveConsignmentSaga),
        fork(watchReceiveSetsGetDropDownSaga),
        fork(watchGetPricesForConsignmentItemsSaga),
        fork(watchCreateReceiveSetsSaga),
        fork(watchGetReceiveSetsDetails),
        fork(watchCheckFromOutsideTerritory),
        fork(watchGetProductDetailsSaga),
        fork(watchGetReceiveSetsProductsSaga),
        //fork(watchGetReceiveSetsProductsDetailsSaga)
    ]);
}
